import { type FC } from "react";
import { ReactComponent as CheckIcon } from "../../../../assets/images/check-24.svg";
import "./style.less";

export interface TabLabelProps {
  label: string;
  completed?: boolean;
}

const TabLabel: FC<TabLabelProps> = ({ label, completed = false }) => (
  <span className="rd-tab-label">
    {completed && (
      <CheckIcon
        className="rd-tab-label__icon"
        data-testid="tab-label-check"
        aria-hidden
      />
    )}
    <span>{label}</span>
  </span>
);

export default TabLabel;
